import React from 'react';
import { useTranslation } from 'react-i18next';

export const EmptyAnalyticsState: React.FC = () => {
  const { t } = useTranslation('analytics');
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[200px] w-full text-center p-6">
      <p className="text-secondary text-sm font-medium italic">{t('empty.noData')}</p>
    </div>
  );
};
